import { render, staticRenderFns } from "./ecocash.vue?vue&type=template&id=01d00702&scoped=true"
import script from "./ecocash.vue?vue&type=script&lang=js"
export * from "./ecocash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d00702",
  null
  
)

export default component.exports